import { render, staticRenderFns } from "./ListBaseItem.vue?vue&type=template&id=1b9b0eb5&scoped=true&lang=pug&"
import script from "./ListBaseItem.vue?vue&type=script&lang=js&"
export * from "./ListBaseItem.vue?vue&type=script&lang=js&"
import style0 from "./ListBaseItem.vue?vue&type=style&index=0&id=1b9b0eb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b0eb5",
  null
  
)

export default component.exports